// shared-lib/cabinet-runs/doorStyles.js
//
// The door styles the app can DRAW — the geometry every cabinet front surface
// (3D, elevation, thumbnail) knows how to build. A family's door DESIGN is what
// it sells and names (`familyOffering`); each design `renders` as one of these.
// The single list: the web renderer and the panel's labels read it from here.
//
// No dependencies on purpose: the renderer imports it, and must not pull the
// fill engine in with it.

const DRAWN_DOOR_STYLES = [
  { id: 'flat', name: 'Flat panel' },
  { id: 'shaker', name: 'Shaker' },
  // A shaker whose stiles and rails are a thin edge (13 mm on Tasoro's Thin
  // Shaker sheet) instead of the usual 2.5" border.
  { id: 'slim-shaker', name: 'Slim Shaker' },
  { id: 'raised-panel', name: 'Raised Panel' },
  { id: 'glass-front', name: 'Glass Front' },
];

const DRAWN_DOOR_STYLE_IDS = DRAWN_DOOR_STYLES.map((d) => d.id);

/** What a cabinet with no `doorStyle` (or an unknown one) is drawn as. */
const DEFAULT_DOOR_STYLE = 'flat';

/** The drawn style for a stored value: unknown or missing → flat. */
function resolveDoorStyle(style) {
  return DRAWN_DOOR_STYLE_IDS.includes(style) ? style : DEFAULT_DOOR_STYLE;
}

/** Styles drawn as a frame (stiles + rails) around a centre panel. */
const FRAMED_DOOR_STYLES = [
  'shaker',
  'slim-shaker',
  'raised-panel',
  'glass-front',
];

/** Does this style draw a frame around a centre panel? */
function isFramedDoorStyle(style) {
  return FRAMED_DOOR_STYLES.includes(style);
}

/** Does this style's centre panel sit flat and recessed inside its frame? */
function isRecessedPanelStyle(style) {
  return style === 'shaker' || style === 'slim-shaker';
}

/**
 * A cabinet with NO DOOR — a run's filler strip, an open shelf, floating
 * shelves or an end shelf. It still
 * takes the run's finish, but it has no door style of its own: a style
 * stored on it (or the flat a missing one resolves to) says nothing about
 * the product, so nothing may judge or choose its finish by that door.
 */
function isDoorlessCabinet(obj) {
  return !!(
    obj &&
    obj.category &&
    (obj.category.filler ||
      obj.category.openShelf ||
      obj.category.floatingShelves ||
      obj.category.endShelf)
  );
}

module.exports = {
  DRAWN_DOOR_STYLES,
  DRAWN_DOOR_STYLE_IDS,
  DEFAULT_DOOR_STYLE,
  resolveDoorStyle,
  FRAMED_DOOR_STYLES,
  isFramedDoorStyle,
  isRecessedPanelStyle,
  isDoorlessCabinet,
};
